<!-- Page Header -->
 <div class="container-fluid">

    <app-page-header header="{{pageTitle}}" description="{{pageSubTitle}}" tooltip="{{pageTitleTooltip}}">
    </app-page-header>
    <div class="trigger-release m-t-10">
        <form #form="ngForm">

            <div class="row m-b-2">
                <div class="col-md-7">
                    <label class="fw-500 mb-0" for="releaseNameLabel">Release Name:&nbsp;</label>
                    <label class="fw-500 mb-0" for="releaseNameLabel">{{releaseName}}</label>
                </div>
            </div>
            <div class="row m-b-2">
                <div class="col-md-7">
                <mat-form-field appearance="fill" class="w-100">
                    <mat-label class="EnvironmentLabel">{{SelectEnvInfoMsg}}</mat-label>
                    <mat-select required name="selectedEnvironment" (selectionChange)="onEnvironmentChange($event.value)"
                        [(ngModel)]="selectedEnvironmentId" aria-label="{{SelectEnvInfoMsg}}">
                        <mat-option>
                            <ngx-mat-select-search ngDefaultControl [formControl]="searchFilterControlEnvironments"
                                placeholderLabel="Search..." noEntriesFoundLabel="'Not found'">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let env of filteredEnvironments" [value]="env.environmentId">
                            {{env.environmentName}}
                        </mat-option> </mat-select>
                </mat-form-field>
                </div>

            </div>

            @if (ShowStagingChkbox){
            <div class="row m-b-3">
                <div class="col-md-7">
                    <mat-checkbox name="isDBSyncInitiated" class="mtpx-5 fids-primary-checkbox m-l-0  p-0"
                        [ngModelOptions]="{standalone: true}" [(ngModel)]="isDBSyncInitiated">
                    </mat-checkbox>
                    <span class="fw-100 mt-2">
                        Initiate DB Sync
                    </span>
                    <span class="info-icon">
                        <span class="info-icon-info">
                            <i class="mr-0 fs-18 material-icons material-icons-info" aria-hidden="true">info</i>
                            <span class="info-tooltip tooltip-left">Opting for this selection will initiate a database
                                synchronization process before the deployment process</span>
                        </span>
                    </span>
                </div>
            </div>
        }
        <div class="row m-b-10">
            <div class="col-md-7" [class.readonly-overlay]="!selectedEnvironmentId">
                <app-ng-select-with-select-all [allItems]="servicesList" [textFieldName]="'serviceName'" name="selectedServices"
                    [valueFieldName]="'serviceName'" [(ngModel)]="selectedServices" [groupFieldName]="'serviceGroup'"
                    [placeholder]="!selectedEnvironmentId ? 'Please select an environment first' : SelectServicesInfoMsg"
                    [required]="true">
                </app-ng-select-with-select-all>
            </div>
        </div>
            <div class="row m-b-10 m-t-5">
                <div class="col-md-7">
                    <quill-editor #editorModel="ngModel" theme="snow" [modules]="quillModules" [styles]="quillStyles"
                        [customOptions]="customQuillOptions"
                        (onEditorCreated)="onQuillEditorCreated($event)"
                        (onBlur)="editorModel.control.markAsTouched()"
                        [(ngModel)]="deploymentPurpose" name="deploymentPurpose"
                        [placeholder]="DeploymentPurposeInfoMsg" required
                        class="quill-editor-error">
                    </quill-editor>
                </div>
            </div>
            <!-- Trigger Release Button -->
            <div class="row m-b-10">
                <div class="col-md-7 trigger-release-end-align">
                    <button class="mdc-button ripple-material" (click)="cancel()" type="button">
                        <span class="mdc-button__ripple"></span> Cancel
                    </button>
                    &nbsp;
                    <button class="mdc-button mdc-button--raised mdc-button--sharp ripple-material" (click)="triggerRelease()"
                        type="button" #submitButton
                        [disabled]="!form.valid || servicesList.length <=0 || !requiredValidationForWYSIWYG()">
                        <span class="mdc-button__ripple"></span>
                        <span class="mdc-button__label"></span>Trigger Release Deployment
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
